import apiSlice from "./ApiSlice";

/** Affidavit stamp tickets, notary seals and serial number (Affidavit Stamp & Seal). */
export const affidavitStampApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAffidavitStamp: builder.query({
      providesTags: ["affidavit-stamp"],
      query: () => ({
        url: "/affidavit-stamp/get",
        method: "GET",
      }),
    }),

    // serialStart, text positions, or { removeImage: kind }
    updateAffidavitStamp: builder.mutation({
      invalidatesTags: ["affidavit-stamp"],
      query: (body: Record<string, any>) => ({
        url: "/affidavit-stamp/update",
        method: "PUT",
        body,
      }),
    }),

    // multipart: field "image"
    uploadAffidavitStamp: builder.mutation({
      invalidatesTags: ["affidavit-stamp"],
      query: ({ kind, body }: { kind: string; body: FormData }) => ({
        url: "/affidavit-stamp/upload",
        params: { kind },
        method: "PUT",
        body,
      }),
    }),

    // The application's serial number, given out on the first call.
    reserveAffidavitSerial: builder.mutation({
      invalidatesTags: ["affidavit-stamp"],
      query: (body: { panId: string }) => ({
        url: "/affidavit-stamp/reserve-serial",
        method: "POST",
        body,
      }),
    }),

    // Its serial (or the next one, preview) + the details last printed.
    getAffidavitForPan: builder.query({
      query: (panId: string) => ({
        url: "/affidavit-stamp/for-pan",
        params: { panId },
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAffidavitStampQuery,
  useLazyGetAffidavitStampQuery,
  useUpdateAffidavitStampMutation,
  useUploadAffidavitStampMutation,
  useReserveAffidavitSerialMutation,
  useLazyGetAffidavitForPanQuery,
} = affidavitStampApi;
